module.exports = __webpack_public_path__ + "static/media/samsung.2d392a2a.png";